import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "hidden lg:grid lg:grid-cols-4 lg:gap-x-8" }
const _hoisted_2 = { class: "lg:space-y-8" }
const _hoisted_3 = ["onMouseenter"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "absolute bottom-0 left-0 -mb-px h-0.5 w-full origin-left scale-x-0 bg-gray-500 transition-transform duration-300 group-hover:scale-x-100" }, null, -1)
const _hoisted_5 = { class: "lg:col-span-3 lg:grid lg:grid-cols-1 lg:grid-rows-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.id,
          onMouseenter: ($event: any) => (_ctx.onHover(item)),
          class: "group relative cursor-pointer border-b border-b-gray-400 border-opacity-30 py-2 text-lg font-bold"
        }, [
          _createElementVNode("span", null, _toDisplayString(item.title), 1),
          _hoisted_4
        ], 40, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}